import {
  CARRIERS,
  RATE_SHOP_CARRIER_IDS,
  SERVICES
} from '../config/rateShopConstants';

const carrierNames = {
  usps: 'USPS',
  ups: 'UPS',
  fedex: 'FedEx',
  fedex_walleted: 'FedEx (ShipStation)',
  amazon_shipping_us: 'Amazon Shipping',
  amazon_buy_shipping: 'Amazon Buy Shipping',
  ship_with_walmart: 'Ship with Walmart',
  wwex_parcel: 'UPS by Worldwide Express'
};
export const serviceSuppliers = code =>
  CARRIERS.filter(
    c =>
      RATE_SHOP_CARRIER_IDS.includes(c.carrierId) &&
      (c.services.some(s => s.code === code) ||
        (code === 'ups_ground_saver' && c.carrierId === 'se-396926'))
  );

/** Unsupported quotes stay discoverable, but do not count as prices Rate Shop can choose. */
export function allowedServiceGroups(selected, carrierAccounts = {}) {
  const services = [
    ...SERVICES,
    ...selected
      .filter(code => !SERVICES.some(s => s.code === code))
      .map(code => ({ code, name: code, carrierCodes: [] }))
  ];
  const groups = {};
  services.forEach(service => {
    const suppliers = serviceSuppliers(service.code);
    const active = suppliers.filter(
      c => carrierAccounts[c.carrierId] !== false
    );
    if (suppliers.length && !active.length) return;
    const codes = active.length
      ? [...new Set(active.map(c => c.carrierCode))]
      : ['other'];
    codes.forEach(code => {
      if (!groups[code])
        groups[code] = {
          code,
          label: carrierNames[code] || 'Other carriers (not used by Rate Shop)',
          supported: code !== 'other',
          services: []
        };
      groups[code].services.push(service);
    });
  });
  return Object.values(groups).sort(
    (a, b) =>
      Number(b.supported) - Number(a.supported) ||
      a.label.localeCompare(b.label)
  );
}
